import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { API_BASE_URL } from '../config/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Helper function to make authenticated requests
const authAxios = {
  post: (url, data, config = {}) => axios.post(url, data, { ...config, headers: { ...config.headers, ...getAuthHeaders() } })
};

function AdminHeader() {
  const navigate = useNavigate();
  const username = localStorage.getItem('username') || sessionStorage.getItem('username') || 'Admin';

  const handleLogout = async () => {
    try {
      await authAxios.post(`${API_BASE_URL}/auth/logout`);
    } catch (err) {
      console.error('Logout error:', err);
    } finally {
      localStorage.removeItem('authToken');
      localStorage.removeItem('username');
      sessionStorage.removeItem('authToken');
      sessionStorage.removeItem('username');
      // Trigger storage event for other tabs
      window.dispatchEvent(new Event('storage'));
      navigate('/login');
    }
  };

  return (
    <header className="mb-6 md:mb-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4 md:mb-6">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Admin Tools</h1>
        </div>
        <div className="flex items-center gap-3 self-start sm:self-auto">
          <span className="text-sm text-gray-600">Logged in as: <strong>{username}</strong></span>
          <a
            href="/admin/bundles"
            className="px-3 py-2 md:px-4 text-sm md:text-base text-blue-600 hover:text-blue-700 font-medium"
          >
            Bundles
          </a>
          <a
            href="/admin/orders"
            className="px-3 py-2 md:px-4 text-sm md:text-base text-purple-600 hover:text-purple-700 font-medium"
          >
            Orders
          </a>
          <a
            href="/admin/marketing"
            className="px-3 py-2 md:px-4 text-sm md:text-base text-blue-600 hover:text-blue-700 font-medium"
          >
            Marketing
          </a>
          <a
            href="/admin/settings"
            className="px-3 py-2 md:px-4 text-sm md:text-base text-gray-600 hover:text-gray-900 font-medium"
          >
            Settings
          </a>
          <button
            onClick={handleLogout}
            className="px-3 py-2 md:px-4 text-sm md:text-base text-white bg-red-600 hover:bg-red-700 rounded-lg font-medium transition-colors"
          >
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}

export default AdminHeader;

